import type { SVGProps } from "react";

const MailIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2.5" y="4.16667" width="15" height="11.6667" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M3.33333 5.41667L8.61672 9.50558C9.42323 10.1367 10.5768 10.1367 11.3833 9.50558L16.6667 5.41667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MailIcon;
